/* FTC shop: in-place design switching, gallery, add to cart, sticky bar. See sections/ftc-shop.liquid. */
(function () {
  if (window.FTCShop) return;
  var cache = {}, io = null;
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function root() { return qs('[data-ftc-shop]'); }
  function path(u) { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return u; } }

  function initGallery() {
    qsa('[data-ftc-gal]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var tr = qs('.ftc-gal__track', g), n = qsa('.ftc-gal__slide', g).length, thumbs = qsa('.ftc-gal__thumb', g);
      var cnt = qs('.ftc-gal__i', g), prev = qs('.ftc-gal__nav--prev', g), next = qs('.ftc-gal__nav--next', g), i = 0, t = null;
      function set(k) { i = k; if (cnt) cnt.textContent = k + 1; thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === k ? 'true' : 'false'); }); if (prev) prev.disabled = k === 0; if (next) next.disabled = k === n - 1; }
      function to(k) { k = Math.max(0, Math.min(n - 1, k)); tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); set(k); }
      tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { set(Math.max(0, Math.min(n - 1, Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth))))); }, 60); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { to(i - 1); });
      if (next) next.addEventListener('click', function () { to(i + 1); });
      thumbs.forEach(function (b, j) { b.addEventListener('click', function () { to(j); }); });
    });
  }

  function initSticky() {
    if (io) { io.disconnect(); io = null; }
    var bar = qs('[data-ftc-satc]'), main = qs('[data-ftc-atc]');
    document.documentElement.style.setProperty('--ftc-satc-h', '0px');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    io = new IntersectionObserver(function (en) {
      var e = en[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      document.documentElement.style.setProperty('--ftc-satc-h', on ? bar.offsetHeight + 'px' : '0px');
    }, { threshold: 0 });
    io.observe(main);
  }

  function initSwitcher(scroll) {
    qsa('[data-ftc-ds]').forEach(function (row) {
      var cur = qs('[aria-current="true"]', row);
      if (scroll && cur && !row.hidden && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, cur.parentNode.offsetLeft - row.offsetLeft - 20);
    });
  }

  function rerun(scope) {
    qsa('script', scope).forEach(function (old) {
      if (old.src || (old.type && old.type !== 'text/javascript' && old.type !== 'module')) return;
      var s = document.createElement('script'); s.textContent = old.textContent; old.parentNode.replaceChild(s, old);
    });
  }

  function load(url) { return cache[url] || (cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).catch(function (e) { delete cache[url]; throw e; })); }

  function go(url, push) {
    var r = root(); if (!r) { location.href = url; return; }
    r.classList.add('is-loading');
    return load(url).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), sections = [];
      if (!doc.querySelector('[data-ftc-swap="buy"]')) throw new Error('no shop in response');
      qsa('[data-ftc-swap]').forEach(function (el) {
        var src = doc.querySelector('[data-ftc-swap="' + el.getAttribute('data-ftc-swap') + '"]');
        if (!src) return;
        el.innerHTML = src.innerHTML;
        var sec = el.closest('.shopify-section') || el; if (sections.indexOf(sec) < 0) sections.push(sec);
      });
      var p = path(url), name = '';
      qsa('[data-ftc-design]').forEach(function (a) { var on = path(a.href) === p; if (on) { a.setAttribute('aria-current', 'true'); name = a.getAttribute('data-name'); } else a.removeAttribute('aria-current'); });
      var lbl = qs('[data-ftc-ds-cur]'); if (lbl && name) lbl.textContent = name;
      sections.forEach(rerun);
      initGallery(); initSticky();
      if (r.getAttribute('data-page') === 'product') { if (push) history.pushState({ ftc: url }, '', url); if (doc.title) document.title = doc.title; }
      r.classList.remove('is-loading');
      window.dispatchEvent(new Event('resize'));
    }).catch(function () { location.href = url; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ftc-design]');
    if (a) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      if (a.getAttribute('aria-current') === 'true') return;
      go(a.href, true); return;
    }
    var tab = e.target.closest && e.target.closest('[data-ftc-tab]');
    if (tab) {
      var id = tab.getAttribute('data-ftc-tab');
      qsa('[data-ftc-tab]').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
      qsa('[data-ftc-panel]').forEach(function (pn) { pn.hidden = pn.getAttribute('data-ftc-panel') !== id; });
      return;
    }
    var sb = e.target.closest && e.target.closest('[data-ftc-satc-btn]');
    if (sb) { var f = qs('[data-ftc-form]'); if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } }
  });
  ['pointerenter', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var a = e.target && e.target.closest && e.target.closest('a[data-ftc-design]'); if (a && a.getAttribute('aria-current') !== 'true') load(a.href).catch(function () {}); }, { capture: true, passive: true });
  });
  window.addEventListener('popstate', function () { var r = root(); if (r && r.getAttribute('data-page') === 'product' && /\/products\//.test(location.pathname)) go(location.href, false); });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ftc-form]'); if (!f) return;
    e.preventDefault();
    var btn = qs('[data-ftc-atc]', f), err = qs('[data-ftc-err]', f), idEl = f.querySelector('[name="id"]');
    if (!idEl || (btn && btn.disabled)) return;
    if (btn) btn.classList.add('is-busy'); if (err) err.hidden = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:update:cart'));
        var lab = btn && qs('[data-ftc-atc-label]', btn), was = lab && lab.textContent;
        if (btn) { btn.classList.remove('is-busy'); btn.classList.add('is-ok'); }
        if (lab) lab.textContent = 'Approved';
        setTimeout(function () { document.dispatchEvent(new CustomEvent('theme:open:cart-drawer')); }, 900);
        setTimeout(function () { if (btn) btn.classList.remove('is-ok'); if (lab && lab.isConnected) lab.textContent = was; }, 2400);
      })
      .catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  });


  /* Photo zoom: tap a gallery photo to open it full screen, tap again to zoom in on that spot and drag/scroll to pan. */
  function zoomOpen(img) {
    var d = qs('.ftc-zoom');
    if (!d) {
      d = document.createElement('dialog'); d.className = 'ftc-zoom';
      d.innerHTML = '<button type="button" class="ftc-zoom__x" aria-label="Close photo">\u00d7</button><div class="ftc-zoom__pan"><img alt=""></div><p class="ftc-zoom__hint">Tap photo to zoom</p>';
      document.body.appendChild(d);
      d.addEventListener('click', function (e) {
        var p = qs('.ftc-zoom__pan', d);
        if (e.target.closest('.ftc-zoom__x')) { d.close(); return; }
        if (e.target.tagName === 'IMG') {
          var r = e.target.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          if (d.classList.toggle('is-in')) { var ctr = function () { p.scrollLeft = fx * p.scrollWidth - p.clientWidth / 2; p.scrollTop = fy * p.scrollHeight - p.clientHeight / 2; }; ctr(); setTimeout(ctr, 60); }
        } else { d.close(); }
      });
    }
    if (!d.showModal) return;
    var src = img.currentSrc || img.src;
    d.classList.remove('is-in');
    var zi = qs('img', d); zi.alt = img.alt || ''; zi.src = src; zi.src = src.replace(/([?&])width=\d+/, '$1width=2400');
    d.showModal();
  }
  document.addEventListener('click', function (e) {
    var im = e.target.closest && e.target.closest('.ftc-gal__slide img'); if (im) zoomOpen(im);
  });

  function boot() { initGallery(); initSticky(); initSwitcher(true); }
  window.FTCShop = { go: go, init: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
